export const customObjectsRouteNames = {
    default: 'objects',
    list: 'custom_objects_list'
}
